import React from 'react'
import {
  JSONFetcher,
  ApiQuery,
  ProjectList
} from 'shared'

export class TopProjectsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isLoading: true, projects: [] }
  }

  componentDidMount() {
    let query = new ApiQuery(this.props.apiBaseUrl)
    query.order({ rank: 'desc' }).per(3).withDefaultFilter()

    JSONFetcher.load({
      url:     query.toUrl(),
      success: (response) => {
        this.setState({ projects: response.data, isLoading: false })
      }
    })
  }

  projectsLoaded = (json) => {
    this.setState({projects: json.data})
  }

  render() {
    return (
      <div>
        <h2 className="font-lg text-center m-b m-t-lg">
          { I18n.t('discover.categories.index.top_projects_headline') }
        </h2>
        <ProjectList
          projects={ this.state.projects }
          isLoading={ this.state.isLoading }
          trackingPath='/discover-projects/list-show/top-projects'
        />
      </div>
    )
  }
}
